<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap align-center class="mb-2">
        <v-flex xs12 sm6 md3 pl-6 pr-3>
          <v-select
            v-model="selectedStaffType"
            :items="availableStaffTypes"
            item-text="name"
            item-value="value"
            label="Loại nhân viên"
            prepend-icon="fa-user-tie"
            @change="filter_data"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3 px-3>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Từ ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md3 px-3>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedEndDateFormatted"
                    label="Đến ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md3 pr-6 pl-3 class="d-flex align-center">
            <v-btn @click="filter_data" color="#0088cc" outlined>Xem</v-btn>
        </v-flex>
        <v-flex lg12>
            <template v-for="(item, i) in displayItems">
                <div v-bind:key="i">
                <h4>Tháng: {{ formatMonth(item.month) }}</h4>
                <v-card class="mb-8">
                    <v-data-table hide-default-footer :headers="headers" :items="item.rows" :server-items-length="item.rows.length" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item: row }">
                            <tr>
                                <td>
                                    <div class="font-weight-medium">{{ getStaffName(row) }}</div>
                                    <div class="caption mt-1">
                                        <a :href="getBaoCaoDoanhThuUrl(item.month, getStaffId(row), 2)" @click.prevent="openOrderDialog(item.month, row, 'bought')" class="text-decoration-none mr-2 font-weight-medium primary--text" title="Xem danh sách đơn mua hàng cấu thành báo cáo">
                                            <v-icon x-small color="primary">mdi-cart-outline</v-icon> Đơn mua
                                        </a>
                                        <a :href="getBaoCaoDoanhThuUrl(item.month, getStaffId(row), 8)" @click.prevent="openOrderDialog(item.month, row, 'completed')" class="text-decoration-none font-weight-medium success--text" title="Xem danh sách đơn hoàn thành cấu thành báo cáo">
                                            <v-icon x-small color="success">mdi-check-circle-outline</v-icon> Đơn HT
                                        </a>
                                    </div>
                                </td>
                                <!-- Đơn mua hàng -->
                                <td class="text-end">
                                    <a :href="getBaoCaoDoanhThuUrl(item.month, getStaffId(row), 2)" @click.prevent="openOrderDialog(item.month, row, 'bought')" class="text-decoration-none font-weight-medium primary--text" title="Xem danh sách đơn mua hàng">
                                        <div>{{ row.TotalAmount | currency('¥', 2)}}</div>
                                        <div class="sub-currency-vnd">{{ row.TotalAmountVND | currency }} ₫</div>
                                    </a>
                                </td>
                                <td class="text-end">
                                    <div>{{ row.TotalRealAmount | currency('¥', 2)}}</div>
                                    <div class="sub-currency-vnd">{{ row.TotalRealAmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end font-weight-medium">
                                    <a :href="getBaoCaoDoanhThuUrl(item.month, getStaffId(row), 2)" @click.prevent="openOrderDialog(item.month, row, 'bought')" class="text-decoration-none" title="Xem danh sách đơn mua hàng">
                                        <div :class="{'green--text text--darken-2': row.TotalDiff > 0, 'red--text text--darken-2': row.TotalDiff < 0}">
                                            {{ row.TotalDiff | currency('¥', 2)}}
                                        </div>
                                        <div class="sub-currency-vnd" :class="{'sub-positive': row.TotalDiff > 0, 'sub-negative': row.TotalDiff < 0}">
                                            {{ row.TotalDiffVND | currency }} ₫
                                        </div>
                                    </a>
                                </td>
                                <td class="text-end font-weight-medium" :class="{'green--text': getNegotiationRate(row, 'bought') > 0}">
                                    {{ getNegotiationRate(row, 'bought') | currency('%', 2)}}
                                </td>
                                <td class="text-end">{{ row.TotalFeeBuyAmount | currency }}</td>
                                <!-- Đơn hoàn thành -->
                                <td class="text-end">
                                    <a :href="getBaoCaoDoanhThuUrl(item.month, getStaffId(row), 8)" @click.prevent="openOrderDialog(item.month, row, 'completed')" class="text-decoration-none font-weight-medium primary--text" title="Xem danh sách đơn hoàn thành">
                                        <div>{{ row.TotalCompletedAmount | currency('¥', 2)}}</div>
                                        <div class="sub-currency-vnd">{{ row.TotalCompletedAmountVND | currency }} ₫</div>
                                    </a>
                                </td>
                                <td class="text-end">
                                    <div>{{ row.TotalCompletedRealAmount | currency('¥', 2)}}</div>
                                    <div class="sub-currency-vnd">{{ row.TotalCompletedRealAmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end font-weight-medium">
                                    <a :href="getBaoCaoDoanhThuUrl(item.month, getStaffId(row), 8)" @click.prevent="openOrderDialog(item.month, row, 'completed')" class="text-decoration-none" title="Xem danh sách đơn hoàn thành">
                                        <div :class="{'green--text text--darken-2': row.TotalCompletedDiff > 0, 'red--text text--darken-2': row.TotalCompletedDiff < 0}">
                                            {{ row.TotalCompletedDiff | currency('¥', 2)}}
                                        </div>
                                        <div class="sub-currency-vnd" :class="{'sub-positive': row.TotalCompletedDiff > 0, 'sub-negative': row.TotalCompletedDiff < 0}">
                                            {{ row.TotalCompletedDiffVND | currency }} ₫
                                        </div>
                                    </a>
                                </td>
                                <td class="text-end font-weight-medium" :class="{'green--text': getNegotiationRate(row, 'completed') > 0}">
                                    {{ getNegotiationRate(row, 'completed') | currency('%', 2)}}
                                </td>
                                <td class="text-end">{{ row.TotalCompletedFeeBuyAmount | currency }}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                                <td class="font-weight-bold">TỔNG</td>
                                <td class="text-end">
                                    <div class="font-weight-bold">{{dic_summary[item.month].TotalAmount | currency('¥', 2)}}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{dic_summary[item.month].TotalAmountVND | currency}} ₫</div>
                                </td>
                                <td class="text-end">
                                    <div class="font-weight-bold">{{dic_summary[item.month].TotalRealAmount | currency('¥', 2)}}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{dic_summary[item.month].TotalRealAmountVND | currency}} ₫</div>
                                </td>
                                <td class="text-end">
                                    <div class="font-weight-bold" :class="{'green--text text--darken-2': dic_summary[item.month].TotalDiff > 0, 'red--text text--darken-2': dic_summary[item.month].TotalDiff < 0}">
                                        {{dic_summary[item.month].TotalDiff | currency('¥', 2)}}
                                    </div>
                                    <div class="sub-currency-vnd font-weight-medium" :class="{'sub-positive': dic_summary[item.month].TotalDiff > 0, 'sub-negative': dic_summary[item.month].TotalDiff < 0}">
                                        {{dic_summary[item.month].TotalDiffVND | currency}} ₫
                                    </div>
                                </td>
                                <td class="text-end font-weight-bold green--text">{{dic_summary[item.month].NegotiationRate | currency('%', 2)}}</td>
                                <td class="text-end font-weight-bold">{{dic_summary[item.month].TotalFeeBuyAmount | currency}}</td>
                                <td class="text-end">
                                    <div class="font-weight-bold">{{dic_summary[item.month].TotalCompletedAmount | currency('¥', 2)}}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{dic_summary[item.month].TotalCompletedAmountVND | currency}} ₫</div>
                                </td>
                                <td class="text-end">
                                    <div class="font-weight-bold">{{dic_summary[item.month].TotalCompletedRealAmount | currency('¥', 2)}}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{dic_summary[item.month].TotalCompletedRealAmountVND | currency}} ₫</div>
                                </td>
                                <td class="text-end">
                                    <div class="font-weight-bold" :class="{'green--text text--darken-2': dic_summary[item.month].TotalCompletedDiff > 0, 'red--text text--darken-2': dic_summary[item.month].TotalCompletedDiff < 0}">
                                        {{dic_summary[item.month].TotalCompletedDiff | currency('¥', 2)}}
                                    </div>
                                    <div class="sub-currency-vnd font-weight-medium" :class="{'sub-positive': dic_summary[item.month].TotalCompletedDiff > 0, 'sub-negative': dic_summary[item.month].TotalCompletedDiff < 0}">
                                        {{dic_summary[item.month].TotalCompletedDiffVND | currency}} ₫
                                    </div>
                                </td>
                                <td class="text-end font-weight-bold green--text">{{dic_summary[item.month].CompletedNegotiationRate | currency('%', 2)}}</td>
                                <td class="text-end font-weight-bold">{{dic_summary[item.month].TotalCompletedFeeBuyAmount | currency}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
                </div>
            </template>
        </v-flex>

        <!-- Dialog xem danh sách đơn hàng cấu thành báo cáo -->
        <v-dialog v-model="dialogOrders" max-width="1450px" scrollable>
            <v-card class="order-dialog-card">
                <v-card-title class="grey lighten-3 d-flex justify-space-between align-center py-2 px-4 dialog-header-border">
                    <div>
                        <div class="subtitle-1 font-weight-bold black--text">Danh sách đơn hàng cấu thành báo cáo</div>
                        <div class="caption mt-1">
                            Nhân viên: <strong class="primary--text">{{ selectedStaffName }}</strong>
                            <span class="mx-2 text--secondary">|</span>
                            Loại nhân viên: <strong class="indigo--text">{{ selectedStaffType === 'customer_service' ? 'CSKH' : 'Mua hàng' }}</strong>
                            <span class="mx-2 text--secondary">|</span>
                            Loại đơn: <strong :class="selectedOrderType === 'bought' ? 'info--text' : 'success--text'">{{ selectedOrderTypeName }}</strong>
                            <span class="mx-2 text--secondary">|</span>
                            Thời gian: <strong>{{ selectedOrderTimeText }}</strong>
                        </div>
                    </div>
                    <div class="d-flex align-center">
                        <v-btn small outlined color="primary" class="mr-2 text-none" :href="selectedReportUrl" target="_blank">
                            <v-icon left small>mdi-open-in-new</v-icon> Xem tại Báo cáo lợi nhuận
                        </v-btn>
                        <v-btn icon small @click="dialogOrders = false" title="Đóng">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-4">
                    <!-- Summary stats -->
                    <v-layout row wrap class="mb-3 mx-n1">
                        <v-flex xs6 sm4 md2 class="pa-1">
                            <v-card flat class="pa-3 text-center summary-stat-card blue-tint">
                                <div class="caption grey--text text--darken-2 font-weight-medium">Số lượng đơn</div>
                                <div class="text-h6 font-weight-bold primary--text mt-1">{{ dialogOrdersList.length }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm4 md2 class="pa-1">
                            <v-card flat class="pa-3 text-center summary-stat-card neutral-tint">
                                <div class="caption grey--text text--darken-2 font-weight-medium">Tổng tiền web+ship</div>
                                <div class="subtitle-1 font-weight-bold mt-1 black--text">{{ dialogSummary.TotalAmount | currency('¥', 2) }}</div>
                                <div class="sub-currency-dialog">{{ dialogSummary.TotalAmountVND | currency }} ₫</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm4 md2 class="pa-1">
                            <v-card flat class="pa-3 text-center summary-stat-card neutral-tint">
                                <div class="caption grey--text text--darken-2 font-weight-medium">Tổng mua thật</div>
                                <div class="subtitle-1 font-weight-bold mt-1 black--text">{{ dialogSummary.TotalRealAmount | currency('¥', 2) }}</div>
                                <div class="sub-currency-dialog">{{ dialogSummary.TotalRealAmountVND | currency }} ₫</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm4 md2 class="pa-1">
                            <v-card flat class="pa-3 text-center summary-stat-card green-tint">
                                <div class="caption grey--text text--darken-2 font-weight-medium">Tổng tiền đàm phán</div>
                                <div class="subtitle-1 font-weight-bold mt-1" :class="{'green--text text--darken-3': dialogSummary.TotalDiff > 0, 'red--text text--darken-2': dialogSummary.TotalDiff < 0}">{{ dialogSummary.TotalDiff | currency('¥', 2) }}</div>
                                <div class="sub-currency-dialog" :class="{'sub-positive': dialogSummary.TotalDiff > 0, 'sub-negative': dialogSummary.TotalDiff < 0}">{{ dialogSummary.TotalDiffVND | currency }} ₫</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm4 md2 class="pa-1">
                            <v-card flat class="pa-3 text-center summary-stat-card green-tint">
                                <div class="caption grey--text text--darken-2 font-weight-medium">Tỷ lệ đàm phán</div>
                                <div class="subtitle-1 font-weight-bold green--text text--darken-3 mt-1">{{ dialogSummary.NegotiationRate | currency('%', 2) }}</div>
                            </v-card>
                        </v-flex>
                        <v-flex xs6 sm4 md2 class="pa-1">
                            <v-card flat class="pa-3 text-center summary-stat-card orange-tint">
                                <div class="caption grey--text text--darken-2 font-weight-medium">Tổng phí dịch vụ</div>
                                <div class="subtitle-1 font-weight-bold amber--text text--darken-4 mt-1">{{ dialogSummary.TotalFeeBuyAmount | currency }}</div>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <!-- Table search & count -->
                    <div class="d-flex align-center justify-space-between mb-2">
                        <div class="caption text--secondary font-weight-medium">
                            Hiển thị <strong>{{ dialogOrdersList.length }}</strong> đơn hàng
                        </div>
                        <v-text-field
                            v-model="orderSearch"
                            placeholder="Tìm kiếm mã đơn, khách hàng..."
                            prepend-inner-icon="mdi-magnify"
                            clearable
                            dense
                            outlined
                            hide-details
                            style="max-width: 300px;"
                        ></v-text-field>
                    </div>

                    <!-- Table of orders -->
                    <v-data-table
                        :headers="orderTableHeaders"
                        :items="dialogOrdersList"
                        :search="orderSearch"
                        :loading="loadingOrders"
                        :items-per-page="10"
                        :footer-props="{ 'items-per-page-options': [10, 20, 50, 100, -1], 'items-per-page-text': 'Hiển thị:' }"
                        class="elevation-1 order-dialog-table"
                    >
                        <template v-slot:item="{ item: orderItem }">
                            <tr>
                                <td class="text-no-wrap font-weight-bold">
                                    <a :href="'/don-hang/' + orderItem.ID" target="_blank" class="primary--text text-decoration-none">
                                        {{ orderItem.OrderCode }}
                                    </a>
                                </td>
                                <td class="text-no-wrap">{{ orderItem.Username }}</td>
                                <td class="text-center text-no-wrap font-weight-medium">
                                    {{ formatOrderDate(orderItem) }}
                                </td>
                                <td class="text-center text-no-wrap">
                                    <v-chip x-small :color="orderItem.Status | order_status_color" :text-color="orderItem.Status | order_status_text_color">
                                        {{ orderItem.Status | order_status }}
                                    </v-chip>
                                </td>
                                <td class="text-end text-no-wrap">
                                    <div>{{ orderItem.AmountCNY | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd">{{ orderItem.AmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap">
                                    <div>{{ orderItem.FeeShipCN | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd">{{ orderItem.FeeShipCNVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap">
                                    <div class="font-weight-bold">{{ orderItem.TotalAmount | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd">{{ orderItem.TotalAmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap">
                                    <div>{{ orderItem.TotalRealAmount | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd">{{ orderItem.TotalRealAmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-medium">
                                    <div :class="{'green--text text--darken-2': orderItem.TotalDiff > 0, 'red--text text--darken-2': orderItem.TotalDiff < 0}">
                                        {{ orderItem.TotalDiff | currency('¥', 2) }}
                                    </div>
                                    <div class="sub-currency-vnd" :class="{'sub-positive': orderItem.TotalDiff > 0, 'sub-negative': orderItem.TotalDiff < 0}">
                                        {{ orderItem.TotalDiffVND | currency }} ₫
                                    </div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-bold" :class="{'green--text text--darken-2': orderItem.NegotiationRate > 0}">
                                    {{ orderItem.NegotiationRate | currency('%', 2) }}
                                </td>
                                <td class="text-end text-no-wrap font-weight-medium">{{ orderItem.FeeBuyAmount | currency }}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr class="summary-total-row">
                                <td colspan="4" class="text-center font-weight-bold">TỔNG CỘNG</td>
                                <td class="text-end text-no-wrap font-weight-bold">
                                    <div>{{ dialogSummary.AmountCNY | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{ dialogSummary.AmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-bold">
                                    <div>{{ dialogSummary.FeeShipCN | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{ dialogSummary.FeeShipCNVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-bold">
                                    <div>{{ dialogSummary.TotalAmount | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{ dialogSummary.TotalAmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-bold">
                                    <div>{{ dialogSummary.TotalRealAmount | currency('¥', 2) }}</div>
                                    <div class="sub-currency-vnd font-weight-medium">{{ dialogSummary.TotalRealAmountVND | currency }} ₫</div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-bold">
                                    <div :class="{'green--text text--darken-3': dialogSummary.TotalDiff > 0, 'red--text text--darken-2': dialogSummary.TotalDiff < 0}">
                                        {{ dialogSummary.TotalDiff | currency('¥', 2) }}
                                    </div>
                                    <div class="sub-currency-vnd font-weight-medium" :class="{'sub-positive': dialogSummary.TotalDiff > 0, 'sub-negative': dialogSummary.TotalDiff < 0}">
                                        {{ dialogSummary.TotalDiffVND | currency }} ₫
                                    </div>
                                </td>
                                <td class="text-end text-no-wrap font-weight-bold green--text text--darken-3">{{ dialogSummary.NegotiationRate | currency('%', 2) }}</td>
                                <td class="text-end text-no-wrap font-weight-bold amber--text text--darken-4">{{ dialogSummary.TotalFeeBuyAmount | currency }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-4 py-2">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-2" outlined small @click="dialogOrders = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            headers: [
                {
                    text: "Nhân viên",
                    value: "BuyerID",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền đơn hàng",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền mua thật",
                    value: "TotalRealAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng chênh lệch",
                    value: "TotalDiff",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tỷ lệ đàm phán",
                    value: "NegotiationRate",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Phí dịch vụ",
                    value: "TotalFeeBuyAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền đơn HT",
                    value: "TotalCompletedAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền mua thật HT",
                    value: "TotalCompletedRealAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng chênh lệch HT",
                    value: "TotalCompletedDiff",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tỷ lệ đàm phán HT",
                    value: "CompletedNegotiationRate",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Phí dịch vụ HT",
                    value: "TotalCompletedFeeBuyAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
            ],
            viewName: "thong-ke-loi-nhuan-dat-hang",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            selectedStaffType: 'purchase',
            staffTypes: [
                { value: 'purchase', name: 'Mua hàng' },
                { value: 'customer_service', name: 'Chăm sóc khách hàng' }
            ],
            dialogOrders: false,
            loadingOrders: false,
            dialogOrdersList: [],
            orderSearch: '',
            selectedBuyerID: null,
            selectedStaffName: '',
            selectedOrderType: 'bought',
            selectedOrderTypeName: '',
            selectedStartTime: '',
            selectedEndTime: '',
            selectedOrderTimeText: '',
            selectedReportUrl: '',
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.orderRevenue.data,
            loading: state => state.report.loading,
            staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
            }),
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            const user = (this.$store.state.authentication && this.$store.state.authentication.user) || {};
            const roleType = Number(user.roletype || user.RoleType || 0);
            return (roleType & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        isPurchaseUser() {
            const user = (this.$store.state.authentication && this.$store.state.authentication.user) || {};
            const roleType = Number(user.roletype || user.RoleType || 0);
            return (roleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        },
        isCustomerServiceUser() {
            const user = (this.$store.state.authentication && this.$store.state.authentication.user) || {};
            const roleType = Number(user.roletype || user.RoleType || 0);
            return (roleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
        availableStaffTypes() {
            if (this.adminRole) {
                return this.staffTypes;
            }
            const list = [];
            if (this.isPurchaseUser) {
                list.push({ value: 'purchase', name: 'Mua hàng' });
            }
            if (this.isCustomerServiceUser) {
                list.push({ value: 'customer_service', name: 'Chăm sóc khách hàng' });
            }
            if (list.length === 0) {
                return this.staffTypes;
            }
            return list;
        },
        orderDateHeaderTitle() {
            return this.selectedOrderType === 'bought' ? 'Ngày mua hàng' : 'Ngày hoàn thành';
        },
        orderTableHeaders() {
            return [
                { text: "MÃ ĐƠN", value: "OrderCode", width: "95px", sortable: true },
                { text: "KHÁCH HÀNG", value: "Username", width: "115px", sortable: true },
                { text: this.orderDateHeaderTitle.toUpperCase(), value: "BoughtDate", align: "center", width: "140px", sortable: true },
                { text: "TRẠNG THÁI", value: "Status", align: "center", width: "105px", sortable: true },
                { text: "TIỀN WEB (¥)", value: "AmountCNY", align: "end", width: "105px", sortable: true },
                { text: "SHIP NỘI ĐỊA (¥)", value: "FeeShipCN", align: "end", width: "95px", sortable: true },
                { text: "TỔNG TIỀN (¥)", value: "TotalAmount", align: "end", width: "110px", sortable: true },
                { text: "MUA THẬT (¥)", value: "TotalRealAmount", align: "end", width: "110px", sortable: true },
                { text: "TIỀN ĐÀM PHÁN (¥)", value: "TotalDiff", align: "end", width: "115px", sortable: true },
                { text: "TỶ LỆ ĐÀM PHÁN", value: "NegotiationRate", align: "end", width: "95px", sortable: true },
                { text: "PHÍ DỊCH VỤ", value: "FeeBuyAmount", align: "end", width: "110px", sortable: true },
            ];
        },
        dialogSummary() {
            const list = this.dialogOrdersList || [];
            const amountCNY = _.sumBy(list, o => Number(o.AmountCNY) || 0);
            const feeShipCN = _.sumBy(list, o => Number(o.FeeShipCN) || 0);
            const totalAmount = _.sumBy(list, o => Number(o.TotalAmount) || 0);
            const totalRealAmount = _.sumBy(list, o => Number(o.TotalRealAmount) || 0);
            const totalDiff = _.sumBy(list, o => Number(o.TotalDiff) || 0);
            const totalFeeBuy = _.sumBy(list, o => Number(o.FeeBuyAmount) || 0);
            const rate = totalAmount > 0 ? (totalDiff / totalAmount * 100) : 0;

            const amountVND = _.sumBy(list, o => Number(o.AmountVND) || 0);
            const feeShipCNVND = _.sumBy(list, o => Number(o.FeeShipCNVND) || 0);
            const totalAmountVND = _.sumBy(list, o => Number(o.TotalAmountVND) || 0);
            const totalRealAmountVND = _.sumBy(list, o => Number(o.TotalRealAmountVND) || 0);
            const totalDiffVND = _.sumBy(list, o => Number(o.TotalDiffVND) || 0);

            return {
                AmountCNY: amountCNY,
                FeeShipCN: feeShipCN,
                TotalAmount: totalAmount,
                TotalRealAmount: totalRealAmount,
                TotalDiff: totalDiff,
                TotalFeeBuyAmount: totalFeeBuy,
                NegotiationRate: rate,
                AmountVND: amountVND,
                FeeShipCNVND: feeShipCNVND,
                TotalAmountVND: totalAmountVND,
                TotalRealAmountVND: totalRealAmountVND,
                TotalDiffVND: totalDiffVND,
            };
        },
        displayItems() {
            const data = this.items;
            if (!data) return [];
            let list = [];
            if (Array.isArray(data)) {
                list = data;
            } else if (typeof data === 'object') {
                list = Object.values(data);
            }
            return list.map(item => {
                if (!item || !item.month) return null;
                const m = String(item.month).trim();
                if (m === '0' || m.length !== 6 || !/^\d{6}$/.test(m)) return null;
                const validRows = (item.rows || []).filter(row => {
                    const name = this.getStaffName(row);
                    return Boolean(name && String(name).trim() !== '');
                });
                return {
                    ...item,
                    rows: validRows
                };
            }).filter(item => item && item.rows && item.rows.length > 0);
        },
        dic_summary() {
            let dic = {};
            const items = this.displayItems || [];
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (!item || !item.month) continue;
                const totalAmount = _.sumBy(item.rows, 'TotalAmount') || 0;
                const totalRealAmount = _.sumBy(item.rows, 'TotalRealAmount') || 0;
                const totalDiff = _.sumBy(item.rows, 'TotalDiff') || 0;
                const totalFeeBuy = _.sumBy(item.rows, 'TotalFeeBuyAmount') || 0;

                const totalCompletedAmount = _.sumBy(item.rows, 'TotalCompletedAmount') || 0;
                const totalCompletedRealAmount = _.sumBy(item.rows, 'TotalCompletedRealAmount') || 0;
                const totalCompletedDiff = _.sumBy(item.rows, 'TotalCompletedDiff') || 0;
                const totalCompletedFeeBuy = _.sumBy(item.rows, 'TotalCompletedFeeBuyAmount') || 0;

                const totalAmountVND = _.sumBy(item.rows, o => Number(o.TotalAmountVND) || 0);
                const totalRealAmountVND = _.sumBy(item.rows, o => Number(o.TotalRealAmountVND) || 0);
                const totalDiffVND = _.sumBy(item.rows, o => Number(o.TotalDiffVND) || 0);

                const totalCompletedAmountVND = _.sumBy(item.rows, o => Number(o.TotalCompletedAmountVND) || 0);
                const totalCompletedRealAmountVND = _.sumBy(item.rows, o => Number(o.TotalCompletedRealAmountVND) || 0);
                const totalCompletedDiffVND = _.sumBy(item.rows, o => Number(o.TotalCompletedDiffVND) || 0);

                dic[item.month] = {
                    'NumberOfOrder': _.sumBy(item.rows, 'NumberOfOrder') || 0,
                    'NumberOfLink': _.sumBy(item.rows, 'NumberOfLink') || 0,
                    'TotalAmount': totalAmount,
                    'TotalRealAmount': totalRealAmount,
                    'TotalDiff': totalDiff,
                    'NegotiationRate': totalAmount > 0 ? (totalDiff / totalAmount * 100) : 0,
                    'TotalFeeBuyAmount': totalFeeBuy,

                    'TotalAmountVND': totalAmountVND,
                    'TotalRealAmountVND': totalRealAmountVND,
                    'TotalDiffVND': totalDiffVND,

                    'TotalCompletedAmount': totalCompletedAmount,
                    'TotalCompletedRealAmount': totalCompletedRealAmount,
                    'TotalCompletedDiff': totalCompletedDiff,
                    'CompletedNegotiationRate': totalCompletedAmount > 0 ? (totalCompletedDiff / totalCompletedAmount * 100) : 0,
                    'TotalCompletedFeeBuyAmount': totalCompletedFeeBuy,

                    'TotalCompletedAmountVND': totalCompletedAmountVND,
                    'TotalCompletedRealAmountVND': totalCompletedRealAmountVND,
                    'TotalCompletedDiffVND': totalCompletedDiffVND,

                    'Reward': _.sumBy(item.rows, 'Reward') || 0,
                    'KPI': totalAmount > 0 ? (totalDiff / totalAmount * 100) : 0
                };
            }
            return dic;
        }
    },
    methods: {
        formatMonth(month) {
            if (!month) return '';
            const m = String(month).trim();
            if (m === '0' || m.length !== 6) return m;
            return m.replace(/(\d{4})(\d{2})/, "$2-$1");
        },
        filter_data: function () {
            var param = {
                staffType: this.selectedStaffType,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
            };
            this.$store.dispatch("report/getOrderRevenue", param);
        },
        getStaffId(row) {
            if (!row) return null;
            return row.StaffID || (this.selectedStaffType === 'customer_service' ? row.CustomerServiceID : row.BuyerID) || row.BuyerID || row.CustomerServiceID;
        },
        getStaffName(target) {
            if (!target) return "";
            if (typeof target === 'object') {
                if (target.StaffName && String(target.StaffName).trim() !== '') {
                    return String(target.StaffName).trim();
                }
                const staffId = this.getStaffId(target);
                if (!staffId) return "";
                const staff = _.find(this.staffs, {
                    ID: Number(staffId)
                });
                return staff ? (staff.FullName || staff.Username) : "";
            }
            const staff = _.find(this.staffs, {
                ID: Number(target)
            });
            return staff ? (staff.FullName || staff.Username) : "";
        },
        getNegotiationRate(row, type) {
            if (type === 'bought') {
                if (row.NegotiationRate !== undefined && row.NegotiationRate !== null) {
                    return row.NegotiationRate;
                }
                const totalAmount = Number(row.TotalAmount) || 0;
                const totalDiff = Number(row.TotalDiff) || 0;
                return totalAmount > 0 ? (totalDiff / totalAmount * 100) : 0;
            } else {
                if (row.CompletedNegotiationRate !== undefined && row.CompletedNegotiationRate !== null) {
                    return row.CompletedNegotiationRate;
                }
                const totalAmount = Number(row.TotalCompletedAmount) || 0;
                const totalDiff = Number(row.TotalCompletedDiff) || 0;
                return totalAmount > 0 ? (totalDiff / totalAmount * 100) : 0;
            }
        },
        getMonthDateRange(monthStr) {
            const m = moment(monthStr, "YYYYMM");
            const filterStart = moment(this.dateRange.startDate).startOf("day");
            const filterEnd = moment(this.dateRange.endDate).startOf("day");

            if (!m.isValid()) {
                return {
                    startTime: filterStart.format(configs.SQL_DATE_FORMAT),
                    endTime: filterEnd.format(configs.SQL_DATE_FORMAT)
                };
            }

            const mStart = m.clone().startOf("month").startOf("day");
            const mEnd = m.clone().endOf("month").startOf("day");

            const start = moment.max(mStart, filterStart).format(configs.SQL_DATE_FORMAT);
            const end = moment.min(mEnd, filterEnd).format(configs.SQL_DATE_FORMAT);
            return { startTime: start, endTime: end };
        },
        getBaoCaoDoanhThuUrl(monthStr, staffId, dateType) {
            const { startTime, endTime } = this.getMonthDateRange(monthStr);
            return `/bao-cao/doanh-thu/?staffType=${this.selectedStaffType}&staffID=${staffId}&dateType=${dateType}&startDate=${startTime}&endDate=${endTime}`;
        },
        openOrderDialog(monthStr, row, type) {
            const staffId = this.getStaffId(row);
            this.selectedBuyerID = staffId;
            this.selectedStaffName = this.getStaffName(staffId) || `ID #${staffId}`;
            this.selectedOrderType = type;
            this.selectedOrderTypeName = type === 'bought' ? 'Đơn mua hàng' : 'Đơn hoàn thành';
            const { startTime, endTime } = this.getMonthDateRange(monthStr);
            this.selectedStartTime = startTime;
            this.selectedEndTime = endTime;
            this.selectedOrderTimeText = `${moment(startTime).format(configs.SHORT_DATE_FORMAT)} - ${moment(endTime).format(configs.SHORT_DATE_FORMAT)}`;
            this.selectedReportUrl = this.getBaoCaoDoanhThuUrl(monthStr, staffId, type === 'bought' ? 2 : 8);

            this.dialogOrders = true;
            this.loadingOrders = true;
            this.dialogOrdersList = [];

            const param = {
                staffID: staffId,
                buyerID: staffId,
                staffType: this.selectedStaffType,
                type: type,
                startTime: startTime,
                endTime: endTime
            };
            this.$store.dispatch("report/getOrderRevenueOrders", param).then(res => {
                this.dialogOrdersList = res && res.data ? res.data : [];
            }).catch(err => {
                console.error(err);
                this.dialogOrdersList = [];
            }).finally(() => {
                this.loadingOrders = false;
            });
        },
        formatOrderDate(orderItem) {
            if (!orderItem) return '-';
            let raw = this.selectedOrderType === 'bought'
                ? (orderItem.BoughtDate || orderItem.RawBoughtDate || orderItem.OrderDate || orderItem.RawOrderDate)
                : (orderItem.CompletedDate || orderItem.RawCompletedDate || orderItem.OrderDate || orderItem.RawOrderDate);

            if (!raw) return '-';

            // Kiểm tra nếu raw bị dính chuỗi format chưa parse (MySQL format specifier)
            if (typeof raw === 'string' && raw.includes('%')) {
                raw = orderItem.RawOrderDate || orderItem.RawBoughtDate || orderItem.RawCompletedDate || orderItem.CreatedDate;
                if (!raw) return '-';
            }

            // Nếu đã đúng định dạng DD/MM/YYYY HH:mm
            if (typeof raw === 'string' && /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}/.test(raw)) {
                return raw;
            }

            const m = moment(raw);
            if (m.isValid()) {
                return m.format('DD/MM/YYYY HH:mm');
            }
            return String(raw);
        }
    },
    mounted() {
        this.$store.dispatch("commons/getAllUsers");
        if (this.$route.query.staffType) {
            this.selectedStaffType = this.$route.query.staffType;
        } else if (!this.adminRole) {
            if (this.isCustomerServiceUser && !this.isPurchaseUser) {
                this.selectedStaffType = 'customer_service';
            } else {
                this.selectedStaffType = 'purchase';
            }
        }
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>

<style scoped>
.dialog-header-border {
    border-bottom: 1px solid #dcdcdc;
}
.summary-stat-card {
    border-radius: 6px;
    border: 1px solid #d1d5db;
    transition: all 0.2s ease;
}
.summary-stat-card:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.blue-tint {
    background-color: #ebf5fb !important;
    border-color: #bce8f1 !important;
}
.neutral-tint {
    background-color: #f9fafb !important;
    border-color: #e5e7eb !important;
}
.green-tint {
    background-color: #f0fdf4 !important;
    border-color: #bbf7d0 !important;
}
.orange-tint {
    background-color: #fffbeb !important;
    border-color: #fde68a !important;
}

/* Header bảng: Nền xanh dương #0088cc chữ trắng sắc nét chuẩn nhận diện hệ thống */
.order-dialog-table >>> thead tr th {
    background-color: #0088cc !important;
    color: #ffffff !important;
    border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
    height: 40px !important;
    padding: 0 6px !important;
    vertical-align: middle;
}
.order-dialog-table >>> thead tr th span {
    color: #ffffff !important;
    font-weight: 700 !important;
    font-size: 12px !important;
    letter-spacing: 0.3px;
    white-space: nowrap !important;
}
.order-dialog-table >>> thead tr th .v-icon {
    color: #ffffff !important;
}

/* Table body & cells */
.order-dialog-table >>> table {
    width: 100% !important;
    border-collapse: collapse;
}
.order-dialog-table >>> tbody tr td {
    padding: 6px 8px !important;
    font-size: 13px !important;
    border-right: 1px solid #e0e0e0 !important;
    border-bottom: 1px solid #e0e0e0 !important;
    height: 38px !important;
}
.order-dialog-table >>> tbody tr td:first-child {
    border-left: 1px solid #e0e0e0 !important;
}
.order-dialog-table >>> tbody tr:hover {
    background-color: #f2f8fc !important;
}

/* Dòng tổng cộng nổi bật */
.order-dialog-table >>> .summary-total-row td {
    background-color: #eaf2f8 !important;
    border-top: 2px solid #0088cc !important;
    border-bottom: 2px solid #0088cc !important;
    border-right: 1px solid #d0d7de !important;
    font-size: 13px !important;
    padding: 8px 8px !important;
}
.order-dialog-table >>> .summary-total-row td:first-child {
    border-left: 1px solid #d0d7de !important;
    color: #0088cc !important;
}

.sub-currency-vnd {
    font-size: 11px;
    font-weight: 400;
    line-height: 1.25;
    color: #757575;
    margin-top: 1px;
}
.sub-currency-vnd.sub-positive {
    color: #388e3c;
    opacity: 0.85;
}
.sub-currency-vnd.sub-negative {
    color: #d32f2f;
    opacity: 0.85;
}
.sub-currency-dialog {
    font-size: 11px;
    font-weight: 400;
    color: #757575;
    margin-top: 2px;
}
.sub-currency-dialog.sub-positive {
    color: #2e7d32;
    opacity: 0.9;
}
.sub-currency-dialog.sub-negative {
    color: #c62828;
    opacity: 0.9;
}
</style>